import type {HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {WEB_APP_CONFIG} from "../../../common/app-config";

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
export const authInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const token = inject(WEB_APP_CONFIG).apiToken;
  if (token) req = req.clone({setHeaders: {Authorization: `Bearer ${token}`}});
  return next(req);
};
